import { runDemo } from "../shared/demoRunner";
import { createLodScene } from "./scene";

runDemo({ createScene: createLodScene });
